import React from 'react';
import { Icon, Tooltip, getHelpCenterLinks } from 'venn-ui-kit';

interface CurrencyHeaderProps {
  label: string;
}

const CurrencyHeader = ({ label }: CurrencyHeaderProps) => (
  <>
    {label}
    <Tooltip content="Returns are converted to your organization’s base currency for analysis" className="text-center">
      <a
        target="_blank"
        className="text-inherit"
        rel="noopener noreferrer"
        href={getHelpCenterLinks().CURRENCY_CONVERSION_ARTICLE_HREF}
        onClick={
          // Hack to communicate to BasicTable not to
          // sort when this is clicked
          (e: React.MouseEvent<HTMLAnchorElement> & { noSort: boolean }) => {
            e.persist();
            e.noSort = true;
          }
        }
      >
        <Icon type="info-circle" prefix="fas" className="ml-[3px]" />
      </a>
    </Tooltip>
  </>
);

export default CurrencyHeader;
